import {Injectable} from '@angular/core';
import {unescapeIdentifier} from '@angular/compiler';

@Injectable()
export class TokenService {
  constructor() {}

  // 从url取出token，进行set到本地
  setTokenAndUserId() {
    console.log('头部url；', window.location.search);
    return new Promise((resolve, reject) => {
      if (this.getQueryString('token')) {
        console.log('设置token',this.getQueryString('token'));
        localStorage.setItem('transtalen-token', this.getQueryString('token'));
      }
      if (this.getQueryString('userIdEncoder')) {
        console.log('设置userIdEncoder',this.getQueryString('userIdEncoder'));
        localStorage.setItem('transtalenuserid', this.getQueryString('userIdEncoder'));
      }
      if (this.getQueryString('source_env')) {
        console.log('设置source_env',this.getQueryString('source_env'));
        localStorage.setItem('source_env', this.getQueryString('source_env'));
      }
      resolve();
    });
  }

  getQueryString(name:string):any{
    let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    let params = window.location.search.substr(1).match(reg);
    if(params!=null) return unescapeIdentifier(params[2]); return null;
  }

  findToken() {
    this.setTokenAndUserId()
    let token = this.getQueryString('token') || localStorage.getItem('transtalen-token')
    console.log('取到的token',token);
    return token ? token : '';
  }

  findUserIdEncoder() {
    this.setTokenAndUserId();
    let userIdEncoder = this.getQueryString('userIdEncoder') || localStorage.getItem('transtalenuserid')
    console.log('取到的userIdEncoder',userIdEncoder);
    return userIdEncoder ? userIdEncoder : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/tokenService.service.ts